/* globals Knitiv */

export default class AccountMenuController {
	/* @ngInject */
	/**
	 * @param {import('angular').route.IRouteParamsService} $routeParams
	 * @param {Knitiv.RootScope} $rootScope
	 */
	constructor($routeParams, $rootScope) {
		this.$rootScope = $rootScope;

		this.entries = {
			infos:         {
				icon: 'fa-cogs',
			},
			mailing: {
				icon: 'fa-envelope',
			},
			password:      {
				icon: 'fa-key',
			},
			workflow: {
				icon: 'fa-users',
			}
		};

		this.page = $routeParams.page;
	}

	isAdmin() {
		return this.$rootScope.context?.profil.admin;
	}
}
